module.exports = __webpack_public_path__ + "img/IMG_3119_L_Foamcore_MockedUp.08266cca.jpg";